<template>
  <v-dialog :value="isActive" persistent max-width="600" scrollable>
    <ValidationObserver v-slot="{ handleSubmit }">
      <v-card :loading="isLoading">
        <v-card-title class="pa-0 shadow-1">
          <v-img
            :src="require('@/assets/illustrations/bg_modal_card.svg')"
            cover
            position="left bottom"
            class="align-center"
            height="65px"
          >
            <v-card-title class="font-weight-medium primary--text">
              {{ isEditMode ? "Actualizar" : "Crear" }} tarea
            </v-card-title>
          </v-img>
        </v-card-title>

        <vuescroll
          :ops="{
            bar: { background: '#bacfcec0', keepShow: true },
          }"
        >
          <v-card-text style="max-height: 450px">
            <v-row>
              <!-- Titulo -->
              <v-col cols="12" class="pb-0">
                <ValidationProvider
                  name="título"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    v-model="payload.title"
                    :error-messages="errors"
                    label="Titulo"
                    rounded
                    filled
                  ></v-text-field>
                </ValidationProvider>
              </v-col>
              <!-- Descripción -->
              <v-col cols="12" class="pb-0">
                <ValidationProvider
                  name="descripción"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    v-model="payload.description"
                    :error-messages="errors"
                    label="Descripción"
                    rounded
                    filled
                  ></v-text-field>
                </ValidationProvider>
              </v-col>

              <v-col cols="12" class="py-0">
                <v-row>
                  <!-- Fecha -->
                  <v-col cols="12" md="6" class="pb-0">
                    <v-menu
                      v-model="menuDate"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <ValidationProvider
                          name="fecha"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <v-text-field
                            v-model="payload.day"
                            label="Fecha"
                            readonly
                            rounded
                            filled
                            v-bind="attrs"
                            v-on="on"
                            :error-messages="errors"
                          ></v-text-field>
                        </ValidationProvider>
                      </template>
                      <v-date-picker
                        no-title
                        v-model="payload.day"
                        @input="menuDate = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <!-- Hora -->
                  <v-col cols="12" md="6" class="pb-0">
                    <v-menu
                      v-model="menuTime"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <ValidationProvider
                          name="hora"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <v-text-field
                            v-model="payload.hour"
                            label="Hora"
                            readonly
                            rounded
                            filled
                            v-bind="attrs"
                            v-on="on"
                            :error-messages="errors"
                          ></v-text-field>
                        </ValidationProvider>
                      </template>
                      <v-time-picker
                        scrollable
                        format="24hr"
                        v-model="payload.hour"
                      ></v-time-picker>
                    </v-menu>
                  </v-col>
                </v-row>
              </v-col>
              <!-- Tipo -->
              <v-col cols="12" class="py-0">
                <ValidationProvider
                  name="tipo de actividad"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-select
                    :disabled="isLoading"
                    v-model="payload.type_activity_id"
                    :items="typeActivityList"
                    :error-messages="errors"
                    item-text="name"
                    item-value="id"
                    prepend-inner-icon="mdi-tag"
                    label="Tpo de actividad"
                    filled
                    rounded
                  ></v-select>
                </ValidationProvider>
              </v-col>
              <!-- Contacto -->
              <v-col cols="12" class="py-0">
                <ValidationProvider
                  name="contacto"
                  rules=""
                  v-slot="{ errors }"
                >
                  <v-select
                    :disabled="isLoading"
                    v-model="payload.contact_id"
                    :items="contactList"
                    :error-messages="errors"
                    item-text="name"
                    item-value="id"
                    prepend-inner-icon="mdi-account"
                    label="Contacto"
                    filled
                    rounded
                  >
                    <template slot="selection" slot-scope="data">
                      <!-- HTML that describe how select should render selected items -->
                      {{ data.item.name + ", " + data.item.lastNAme }}
                    </template>
                    <template v-slot:item="{ item, on, attrs }">
                      <v-list-item two-line selectable v-bind="attrs" v-on="on">
                        <v-list-item-content>
                          <v-list-item-title>
                            {{ item.name + ", " + item.lastNAme }}
                          </v-list-item-title>
                          <v-list-item-subtitle>
                            {{ item.email }}
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-select>
                </ValidationProvider>
              </v-col>
            </v-row>
          </v-card-text>
        </vuescroll>
        <v-card-actions>
          <v-btn
            @click="closeDialog()"
            class="px-8"
            color="error"
            rounded
            large
            text
          >
            Cerrar
          </v-btn>
          <v-spacer></v-spacer>

          <v-btn
            @click="handleSubmit(submitForm)"
            :disabled="isLoading"
            class="px-8"
            color="success"
            rounded
            large
          >
            {{ isEditMode ? "Actualizar" : "Crear" }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </ValidationObserver>
  </v-dialog>
</template>

<script>
import { PbxHttpClient } from "@/services/httpclient";
import axios from "axios";
import vuescroll from "vuescroll";

export default {
  props: {
    isActive: {
      type: Boolean,
    },
    isEditMode: {
      type: Boolean,
      default: false,
    },
    dataToEdit: {
      type: Object,
      default: {},
    },
  },

  data() {
    return {
      isLoading: false,
      menuDate: false,
      menuTime: false,
      typeActivityList: [],
      contactList: [],
      payload: {
        title: "",
        description: "",
        day: "",
        hour: "",
        type_activity_id: null,
        contact_id: null,
      },
    };
  },

  created() {
    this.getTypeActivity();
    this.payload = { ...this.dataToEdit };
  },

  methods: {
    resetform() {
      this.payload.title = "";
      this.payload.description = "";
      this.payload.day = "";
      this.payload.hour = "";
      this.payload.type_activity_id = null;
    },

    closeDialog(data = false) {
      this.$emit("close:dialog", data);
    },

    getTypeActivity() {
      // this.isLoading = true;

      const accessToken = localStorage.getItem("token");

      let endpoints = [
        `${process.env.VUE_APP_ROOTAPI}/organize/activity`,
        `${process.env.VUE_APP_ROOTAPI}/contacts/select`,
      ];

      axios
        .all(
          endpoints.map((endpoint) =>
            axios.get(endpoint, {
              headers: {
                Authorization: `Bearer ${accessToken}`,
              },
            })
          )
        )
        .then((res) => {
          this.typeActivityList = res[0].data;
          this.contactList = res[1].data;
          // console.log("Listo", res);
        })
        .catch((error) => {
          // console.error(error);
          this.$snotify.error("Hubo un error en la consulta.", "Error");
        });
      // .finally(() => {
      //   this.isLoading = false;
      // });
    },

    async submitForm() {
      this.isLoading = true;

      const accessToken = localStorage.getItem("token");

      const { id, ...payload } = this.payload;

      try {
        const { id, ...payload } = this.payload;
        const { data } = this.isEditMode
          ? await PbxHttpClient.put(`/organize/calendar/${id}`, payload)
          : await PbxHttpClient.post("/organize/calendar", payload);
        this.closeDialog(data.calendar);

        this.$snotify.success("Evento creado con éxito.", "¡Hecho!");
      } catch (err) {
        this.$snotify.error("No se pudo realizar la acción.", "¡Error!");
      }
    },
  },
};
</script>
